import type { SvgIconComponent } from "@mui/icons-material";
import { Stack, Typography } from "@mui/material";
import type { PropsWithChildren } from "react";

interface Props {
  Icon: SvgIconComponent;
  label: string;
}

const ImportDataDetailsAttribute = ({ Icon, label, children }: PropsWithChildren<Props>) => {
  return (
    <Stack direction="row" spacing={1.5} sx={{ width: "100%", alignItems: "flex-start" }}>
      <Stack direction="row" spacing={1.5} sx={{ alignItems: "center", width: "10rem", py: 1 }}>
        <Icon color="action" />
        <Typography color="textSecondary">{label}</Typography>
      </Stack>
      <Stack sx={{ py: 1 }}>{children}</Stack>
    </Stack>
  );
};

export default ImportDataDetailsAttribute;
